import React from "react";
import Button from "components/button";
import { InputField } from "components/fields";

/** Pastoral follow-up request: name plus an email or phone number. */
const ContactOptIn = ({ contact, onChange, submitting, onSubmit, onSkip }) => {
  const update = (field) => (e) => onChange(field, e.target.value);
  const canSubmit = Boolean(contact.email || contact.phone);

  return (
    <form
      noValidate
      onSubmit={(e) => {
        e.preventDefault();
        if (canSubmit) onSubmit();
      }}
    >
      <h1 className="text-center text-title">Stay Connected</h1>
      <p className="mt-2 text-center text-sm text-fg-muted">
        Would you like someone from our team to follow up with you?
      </p>

      <div className="mt-8 flex flex-col gap-4">
        <div className="grid grid-cols-2 gap-3">
          <InputField
            label="First Name"
            autoComplete="given-name"
            placeholder="First"
            value={contact.firstName}
            onChange={update("firstName")}
          />
          <InputField
            label="Last Name"
            autoComplete="family-name"
            placeholder="Last"
            value={contact.lastName}
            onChange={update("lastName")}
          />
        </div>
        <InputField
          label="Email"
          type="email"
          autoComplete="email"
          placeholder="your@email.com"
          value={contact.email}
          onChange={update("email")}
        />
        <InputField
          label="Phone"
          type="tel"
          autoComplete="tel"
          placeholder="(555) 123-4567"
          value={contact.phone}
          onChange={update("phone")}
          hint="Please provide at least an email or phone number."
        />
      </div>

      <Button type="submit" size="lg" fullWidth className="mt-6" disabled={!canSubmit} loading={submitting}>
        {submitting ? "Saving…" : "Yes, Follow Up With Me"}
      </Button>
      <Button variant="ghost" fullWidth className="mt-2" onClick={onSkip} disabled={submitting}>
        No Thanks, I'm All Set
      </Button>
    </form>
  );
};

export default ContactOptIn;
